















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class AlertWarning extends Vue {
  @Prop({ default: '80' }) readonly size?: string;
}
